// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z-KR","index":"styles_index__Mp_Sx"};